import axios from "axios";
import { apiPath, apiPath1 } from "../../constants/config";
let token = localStorage.getItem("accessToken");
let config = {
  headers: {
    Authorization: "Bearer " + token
  }
};
const state = {
  currencies: [],
  currentCyrrency: {}
};

const getters = {
  currencies: state => state.currencies,
  currentCyrrency: state => state.currentCyrrency
};

const mutations = {
  addCurrencies(state, payload) {
    // alert("FROM MUTATE CURRENCIES");
    state.currencies = payload;
  }
};

const actions = {
  getCurrencies({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    return axios.get(`${apiPath}/getCurrencies`, payload, config).then(r => r);
  },
  getChangeCurrencies({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    return axios
      .get(`${apiPath}/getChangeCurrencies`, payload, config)
      .then(r => r);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
